import React, { useEffect, useState } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationBell from "./NotificationBell";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../../reducks/users/selectors";
import { isCurrentDateWithinRange } from "../../../functions/utils/formatting";
import { IconButton } from "@material-ui/core";
import { push } from "connected-react-router";

const BellController = () => {
  const [isNoticeCount, setIsNoticeCount] = useState(0);
  const userInfo = useSelector(getUserInfo);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    const articleRef = collection(db, "articles");
    const unsubscribe = onSnapshot(articleRef, (snapshot) => {
      const latestArticles = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => {
          // createdDay の降順で比較
          if (a.createdDay > b.createdDay) return -1;
          if (a.createdDay < b.createdDay) return 1;
          // createdDay が同じ場合、updatedAt の降順で比較
          return b.updatedAt.toDate() - a.updatedAt.toDate();
        });

      // 条件に基づいてカウントする処理
      const count = latestArticles.filter((article) => {
        const {
          publishStatus,
          notice,
          noticeFromDate,
          noticeToDate,
          targetUsers,
        } = article;

        // 条件チェック
        const isPublished = publishStatus === "公開";
        const isNoticeTrue = notice === true;
        const isDateWithinRange = isCurrentDateWithinRange(
          noticeFromDate,
          noticeToDate
        );

        // userInfo.email と一致し、isOpened が false であるユーザーがいるか、もしくは一致する email がない場合
        const targetUserCheck =
          targetUsers.some(
            (user) => user.email === userInfo.email && !user.isOpened
          ) || !targetUsers.some((user) => user.email === userInfo.email);

        return (
          isPublished && isNoticeTrue && isDateWithinRange && targetUserCheck
        );
      }).length;

      setIsNoticeCount(count);
      setIsLoading(false);
    });

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe();
  }, [userInfo.email]);
  useEffect(() => {
    setIsNoticeCount(0);
  }, []);
  useEffect(() => {
    console.log("isNoticeCount", isNoticeCount);
  }, [isNoticeCount]);
  return (
    <>
      {isLoading ? null : isNoticeCount > 0 ? (
        <NotificationBell count={isNoticeCount} />
      ) : (
        <div style={{ marginTop: "-10px" }}>
          <IconButton
            onClick={() => {
              dispatch(push(`/notice/list`));
            }}
          >
            <NotificationsIcon style={{ fontSize: "32px", color: "#cccccc" }} />
          </IconButton>
        </div>
      )}
    </>
  );
};

export default BellController;
/*latestArticleの内次の条件を満たすものの数をsetIsNoticeCountにセットする処理を追加してください
  latestArticleはフィールドを持つオブジェクトの配列です。
  次のすべての条件に当てはまるlatestArticleの数をカウントしてください。
  publishStatusが"公開"である。
  noticeがtrueである。
  noticeFromDateとnoticeToDateが現在の日付の範囲内である。
  こちらで用意した 以下の関数を使用してください。
  export const isCurrentDateWithinRange = (fromDate, toDate) => {
  // fromDate, toDate をパースして Date オブジェクトに変換
  const start = parseISO(fromDate);
  const end = parseISO(toDate);

  // 現在の日付が fromDate と toDate の間にあるかを判定
  return isWithinInterval(new Date(), { start, end });
 };
 targetUsers（emailとisOpenedのフィールドを持つオブジェクトの配列）に
 userInfo.emailと一致するemailがあり、isOpendがfalseである場合、または、userInfo.emailと一致するemailがない場合


*/
